export const PORTFOLIO_DETAILS_SUCCESS = 'PORTFOLIO/DETAILS_SUCCESS'
export const PORTFOLIO_DETAILS_FAILED = 'PORTFOLIO/DETAILS_FAILED'

export const PORTFOLIO_DEPOSITING_SUCCESS = 'PORTFOLIO/DEPOSITING_SUCCESS'
export const PORTFOLIO_DEPOSITING_FAILED = 'PORTFOLIO/DEPOSITING_FAILED'